import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import FooterLink from './footerLink';
import FooterSocialLink from './footerSocialLink';
import { useSelector } from 'react-redux';
import { IReduxStateData } from '../../interfaces/redux';
import { FOOTER_MENU } from '../../constant/menuAndProfile';

export default function Footer() {
    const globalState = useSelector((state: IReduxStateData) => state);
    return (
        <footer id='footer-container'>
            <Container>
                <Row className="justify-content-end">
                    <Col md={9} lg={8} xl={7}>
                        <FooterLink />
                    </Col>
                    <Col md={3} className="text-center text-md-left mt-3 mt-md-0">
                        <h3 className="h5 bold mb-3">{FOOTER_MENU[globalState?.selectedLang]['follow_us_on']}:</h3>
                        <FooterSocialLink />
                    </Col>
                </Row>
            </Container>
        </footer>
    )
}
